import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const CHOOSE_CONRACT_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
